import { render, staticRenderFns } from "./customVariable.vue?vue&type=template&id=2e31da18"
import script from "./customVariable.vue?vue&type=script&lang=js"
export * from "./customVariable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports